const UNAUTHENTICATED_ROUTES = {
    LOGIN: '/login',
}



export default UNAUTHENTICATED_ROUTES